import React from "react";
import "./KSwitch.css";

interface Props {
  checked: boolean;
  name: string;
  onChange: (v) => void | any;
  label?: string;
  switchLabel?: string;
  style?: any;
  disabled?: boolean;
}

const KSwitch = ({
  checked,
  name,
  onChange,
  label = undefined,
  switchLabel = "",
  style = {},
  disabled = false,
}: Props) => {
  return (
    <div style={{ marginTop: "16px", ...style }}>
      {label !== undefined ? (
        <p className={disabled ? "switch-title-disabled" : "switch-title"}>
          {label}
        </p>
      ) : null}
      <div style={{ marginTop: "6px" }}>
        <input
          type="checkbox"
          id={name}
          name={name}
          checked={checked}
          className="switch-input"
          onChange={onChange}
          disabled={disabled}
        />
        <label
          htmlFor={name}
          className={disabled ? "switch-label-disabled" : "switch-label"}
        >
          {!switchLabel ? (checked ? "On" : "Off") : switchLabel}
        </label>
      </div>
    </div>
  );
};

export default KSwitch;
